import request from '@/utils/request'

export function fetchPackageList (query) {
  return request({
    url: '/card/api/package/index',
    method: 'get',
    params: query
  })
}

export function fetchPackage (id) {
  return request({
    url: '/card/api/package/view',
    method: 'get',
    params: { id }
  })
}

export function createPackage (data) {
  return request({
    url: '/card/api/package/insert',
    method: 'post',
    data
  })
}

export function updatePackage (data) {
  return request({
    url: '/card/api/package/update',
    method: 'post',
    data
  })
}

export function deletePackage (id) {
  return request({
    url: '/card/api/package/delete',
    method: 'post',
    params: { id }
  })
}

export function updatePackageItems (id, items) {
  return request({
    url: '/card/api/package/item_update',
    method: 'post',
    params: { id, items }
  })
}

export function fetchCycleList (query) {
  return request({
    url: '/card/api/package/cycle',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/card/api/package.js